import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function ShortText(text) {
  const shortText = text.split(" ").slice(0, 20).join(" ");

  return <span>{shortText}{text.split(" ").length > 20 ? "..." : ""}</span>;
}

const Banner = ({peopledetails}) => {

     const { t, i18n } = useTranslation()
  return (
    <div className="management-team-column">
                    <div className="team-content">
                       <Link to={peopledetails.readmore}><img src={`img/${peopledetails.img}`} alt=""/></Link> 
                        <div className="content-info">
                            <h3>{peopledetails.name}</h3>
                            <h4>{peopledetails.title}</h4>
                            <p>{ShortText(peopledetails.description)}</p>
                            <div className="banner-rtg-btn d-flex">
                                <Link to={peopledetails.readmore} className="cfn-global-btn">{t("Read_More")}</Link>
                            </div>
                        </div>
                    </div>
                </div>
  );
};

export default Banner;